module.exports = __webpack_public_path__ + "static/omega_g8-75b3240ad7828654c774a45066a18212.jpg";